import React, { useMemo } from "react";
import { FormatValueDecimal } from "../../utils/Validate";

const OrderSummary = ({ orderData }) => {
    const summary = useMemo(() => {
        const list = orderData?.payload || [];
        const totalOrders = list.length;
        const totalValue = list.reduce((sum, o) => sum + (o?.grandTotal || 0), 0);
        const avgValue = totalOrders > 0 ? totalValue / totalOrders : 0;

        const totalUnits = list.reduce((sum, o) => {
            const orderUnits = (o?.products || []).reduce(
                (pSum, p) => pSum + (p?.lpoQuantity || 0),
                0
            );
            return sum + orderUnits;
        }, 0);

        const now = new Date();
        const thisMonthOrders = list.filter((o) => {
            if (!o?.createdAt) return false;
            const d = new Date(o.createdAt);
            return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
        }).length;

        const cancelledOrders = list.filter((o) => o?.cancelStatus === true).length;

        return { totalOrders, totalValue, avgValue, totalUnits, thisMonthOrders, cancelledOrders };
    }, [orderData]);

    return (
        <div className="row order-table-row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="quote-general-stats-strip order-summary-strip">
                    <div className="quote-general-stat">
                        <span>Total Orders</span>
                        <strong>{summary.totalOrders}</strong>
                    </div>
                    <div className="quote-general-stat">
                        <span>Order Value</span>
                        <strong>{FormatValueDecimal(summary.totalValue)}</strong>
                    </div>
                    <div className="quote-general-stat">
                        <span>Avg Order Value</span>
                        <strong>{FormatValueDecimal(summary.avgValue)}</strong>
                    </div>
                    <div className="quote-general-stat">
                        <span>Total Units</span>
                        <strong>{summary.totalUnits}</strong>
                    </div>
                    <div className="quote-general-stat">
                        <span>This Month</span>
                        <strong>{summary.thisMonthOrders}</strong>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderSummary;